// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"67":"4fcaa293","403":"c4d42a61","442":"22ca95b0","464":"f80cbd25","496":"2e3e18a4"}[chunkId] + ".chunk.js";
};